import { Box } from '~/eds/src/components/Box/Box';
import { DateInput } from '~/eds/src/components/DateInput/DateInput';
import { useFormatDate } from '~/i18n/hooks/useFormatDate/useFormatDate';
import { DateFormat } from '~/i18n/hooks/useFormatDate/utils';
import { parseUserDate } from '~/i18n/utils';

import { BaseFieldProps } from './fieldTypes';

interface DateFieldProps extends BaseFieldProps {
  onDateChange: (
    date: Date | null,
    fieldId: number,
    format: DateFormat,
  ) => void;
}

export const DateField = ({
  field,
  editMode,
  editData,
  onDateChange,
  isWssField,
}: DateFieldProps) => {
  const formatDate = useFormatDate();
  const date = editData[field.id];

  if (editMode) {
    return (
      <Box flex="1">
        <DateInput
          name={field.name}
          value={date ? parseUserDate(String(date)) : null}
          onChange={(date) => onDateChange(date, field.id, 'iso')}
          disabled={!field.is_editable || isWssField(field)}
          width="100%"
        />
      </Box>
    );
  }

  return formatDate(
    field.value && !Array.isArray(field.value)
      ? field.value.display_value
      : null,
    'long',
  );
};
